"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
exports.AcFormFieldLabel = function (_a) {
    var label = _a.label, required = _a.required, readOnly = _a.readOnly;
    if (!label)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        required && !readOnly && (react_1.default.createElement("span", { className: "badge badge-danger ml-1 fs-10", style: { padding: '3px 4px' } }, "\u5FC5\u9808"))));
};
exports.AcFormFieldLabel.displayName = 'AcFormFieldLabel';
//# sourceMappingURL=AcFormFieldLabel.js.map